import { render, staticRenderFns } from "./grade.vue?vue&type=template&id=b1dc62c6&scoped=true&"
import script from "./grade.vue?vue&type=script&lang=js&"
export * from "./grade.vue?vue&type=script&lang=js&"
import style0 from "./grade.vue?vue&type=style&index=0&id=b1dc62c6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1dc62c6",
  null
  
)

export default component.exports